import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./VerifyPage.css";
import logo from "./assets/logo.png";
import click from "./assets/sounds/click.mp3";
import frFlag from "./assets/fr.png";
import enFlag from "./assets/en.png";
import { useTranslation } from "react-i18next";

export default function VerifyPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [status, setStatus] = useState("loading"); // loading | success | invalid
  const [message, setMessage] = useState("");

  const API_URL = process.env.REACT_APP_API_URL;

  const playSound = (sound) => {
    const audio = new Audio(sound);
    audio.play();
  };

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus("invalid");
        setMessage(t("verify.missingToken"));
        return;
      }

      try {
        const res = await fetch(`${API_URL}/api/auth/verify/${token}`);
        const data = await res.json();

        if (!res.ok) {
          setStatus("invalid");
          setMessage(data.message || t("verify.invalidToken"));
        } else {
          setStatus("success");
          setMessage(data.message || t("verify.successMessage"));
        }
      } catch (err) {
        console.error(err);
        setStatus("invalid");
        setMessage(t("verify.serverError"));
      }
    };

    verifyEmail();
  }, [token, t]);

  return (
    <div className="verify-container">
      <img src={logo} alt="VinOdys’sait" className="logo" />

      {/* Sélecteur de langue */}
      <div className="lang-switch">
        <img src={frFlag} alt="FR" onClick={() => changeLang("fr")} />
        <img src={enFlag} alt="EN" onClick={() => changeLang("en")} />
      </div>

      <h2>{t("verify.title")}</h2>

      {status === "loading" && <p>{t("verify.loading")}</p>}

      {status === "success" && (
        <>
          <p className="success-msg">{message}</p>
          <button
            className="back-btn"
            onClick={() => {
              playSound(click);
              navigate("/");
            }}
          >
            ← {t("verify.backToLogin")}
          </button>
        </>
      )}

      {status === "invalid" && (
        <>
          <p className="error-msg">{message}</p>
          <button
            className="back-btn"
            onClick={() => {
              playSound(click);
              navigate("/");
            }}
          >
            ← {t("verify.backToLogin")}
          </button>
        </>
      )}
    </div>
  );
}